import { say } from "../../words.ts";
import type { BadgeLook, BadgeType } from "./look.ts";

/**
 * The words of a staff badge (ADR-112 decision 4.2): its accessible name and its hover line, from the language files.
 */

/**
 * The key of each Guide badge's words by its chevrons: new, 1 year, 2 years, 3 years or more.
 */
const GUIDE_WORDS = { 1: "staff.guide.new", 2: "staff.guide.oneYear", 3: "staff.guide.twoYears", 4: "staff.guide.threeYears" } as const;

/**
 * A badge's name: the type's word, a Guide's own words for each of its four chevrons ("Guide, new" to "Guide, 3 years or more"), and the type's word with ", team leader"
 * for a leader's.
 *
 * @param look The badge's look, or null for no badge.
 * @returns The words; empty for no badge.
 * @example
 * badgeName(badgeLook(7));
 * // "Player Support, team leader"
 */
export function badgeName(look: BadgeLook | null): string {
  if (look === null) {
    return "";
  }
  if (look.type === "guide") {
    return say(GUIDE_WORDS[look.badge as 1 | 2 | 3 | 4]);
  }
  const type = say(`staff.type.${look.type}` as `staff.type.${Exclude<BadgeType, "guide">}`);
  return look.leader ? say("staff.leader", { type }) : type;
}
